import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { AlertController, NavController, ToastController, ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from '../../../service/util.service';
import { UserProfile } from '../../../models/user-profile.model';
import { Storage } from '@ionic/storage';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProductRequestService } from '../product-request.service';
import { ProductRequestBundle } from '../../../models/product-request-bundle.model';
import { ProductRequestStatus } from '../../../enum/ProductRequestStatus';
import { UserData } from '../../../providers/user-data';
import { RoleAccess } from '../../../models/role-access.model';
import { FindProductComponent } from '../../../component/find-product/find-product.component';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { environment } from '../../../../environments/environment';
import { MyService } from '../../../service/my.service';
import { PoAutoPreviewComponent } from '../../../component/po-auto-preview/po-auto-preview.component';

import * as XLSX from "xlsx";

class Product {
  public id: string;
  public product_name: string;
}

@Component({
  selector: 'app-product-request-detail',
  templateUrl: './product-request-detail.page.html',
  styleUrls: ['./product-request-detail.page.scss'],
})
export class ProductRequestDetailPage implements OnInit {

  @ViewChild("fileInput", { static: false }) fileInput: ElementRef;

  token: any;
  userProfile: UserProfile = new UserProfile();
  productRequestId: any;
  productList: Product[];
  counterList: any[] = [];
  warehouseList: any[] = [];
  productRequestData: any;
  productRequestDetailData: any[] = [];
  approvalHistoryData: any[] = [];
  createdBy: any;
  createdAt: any;
  updatedBy: any;
  updatedAt: any;
  unitType: any[] = ['PIECES'];
  statusRequest: any = 0;
  statusName: any;
  productRequestDetailList: any[] = [];

  formProductRequestDetail: FormGroup;

  requestStatus = ProductRequestStatus;
  requestStatusList = Object.keys(ProductRequestStatus).filter(
    requestStatus => typeof this.requestStatus[requestStatus] === 'number'
  );

  userAccess: any[] = [];
  roleAccess = new RoleAccess();
  roleName: any;

  timezone: any[] = ['Asia/Jakarta', 'Asia/Makassar', 'Asia/Jayapura'];
  showProposal:boolean=false;
  isApproval = 'N';
  currentLevel =0;
  addProduct = 'N';
  approvalName ='';
  activityHistory=[];
  formActionType:any='';
  isEditProposal:boolean=false;
  proposalList:any[]=[];
  counterId: any = "";
  counterCode:any="";
  usedProposalList:any[]=[];
  proposalNumber:any="";
  proposalDesc:any='';
  proposalStartDate:any='';
  proposalEndDate :any='';
  loadProposal:boolean=false;
  warehouseType:string='R';
  isInitialLoad = true;  
  productPriceGroup:any[]=[];
  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private utilService: UtilService,
    private navCtrl: NavController,
    private toastCtrl: ToastController,
    private alertController: AlertController,
    private modalController: ModalController,
    private storage: Storage,
    private requestService: ProductRequestService,
    private router: Router,
    private userDataProvider: UserData,
    private myService:MyService
  ) { }


  

  ngOnInit() {
    this.buildFormProductRequestDetail();

    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userDataProvider.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.getAllProduct();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }
  ionViewWillEnter() {
    this.addProduct = 'N';
    this.isEditProposal=false;
    
  }
  getAllProduct() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.requestService.getProduct({ "token": this.token }).subscribe((response) => {
        if (response.status.code === 200) {
          this.productList = response.results;
        }
        this.getData();
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  getData() {
    this.counterId ='';
    this.counterCode ='';
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.productRequestId = AES.decrypt(snapshot.i, myKey).toString(utf8);
      let action = AES.decrypt(snapshot.a, myKey).toString(utf8);
      this.formActionType = 'detail';
      if(action=='2'){
        this.formActionType = 'approval';
      }
      this.productRequestId = this.productRequestId.replaceAll('"','');
      let options = {
        "token": this.token,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
      };
      this.requestService.getRequestforEdit(this.productRequestId, options)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        
        this.productPriceGroup = response.results.products;
        this.productRequestData = response.results.product_request_data;
        this.productRequestDetailData = response.results.product_request_detail_data;
        this.counterList = response.results.counter_data;
        this.warehouseList = response.results.warehouse_data;
        let userCreate: any = response.results.user_create_data;
        this.createdBy = userCreate ? userCreate[0].name : null;
        let userUpdate: any = response.results.user_update_data;
        this.updatedBy = userUpdate ? userUpdate[0].name : null;
        this.approvalHistoryData = response.results.approval_history_data;
        this.activityHistory = response.results.activity_history;
        this.counterId = this.productRequestData[0].counter_id;
        let findCounter = this.counterList.find(x=>x.id==this.counterId);
        if(findCounter){
          this.counterCode = findCounter.counter_code;
        }
        this.usedProposalList =  response.results.used_proposal;
        if(this.approvalHistoryData.length>0){
          this.isApproval='N';
          this.approvalName = 'Waiting Approval : ';
          for(let ah=0;ah<this.approvalHistoryData.length;ah++){
            if(this.approvalHistoryData[ah].status=='0' && this.approvalHistoryData[ah].username==this.userProfile.username ){
              this.isApproval='Y';
              this.currentLevel = parseInt(this.approvalHistoryData[ah].level);
            }
            if(this.approvalHistoryData[ah].status=='0'){
              this.approvalName += this.approvalHistoryData[ah].name+' / ';
            }
          }this.approvalName = this.approvalName.replace(/\s*\/\s*$/, '');

        }
        if(this.productRequestData.length > 0) {
          this.statusRequest = this.productRequestData[0].status;
          this.createdAt = this.productRequestData[0].created_at;
          this.updatedAt = this.productRequestData[0].updated_at;
          this.statusName = this.requestStatusList[parseInt(this.statusRequest)];
          if(this.statusRequest==0 && this.productRequestData[0].po_auto=='N'){
            this.addProduct='Y';
          }
          this.buildFormProductRequestDetail();
        }
        if(this.productRequestDetailData.length > 0) {
          this.productRequestDetailList = [];
          for(let i = 0; i < this.productRequestDetailData.length; i++) {
            let price = 0;
            if(this.formActionType=='detail' && (this.statusRequest !== '0' &&this.statusRequest !== '8')){
              price=this.productRequestDetailData[i].price;
            }
            else{
              let findPrice = this.productPriceGroup.find(x=>x.id==this.productRequestDetailData[i].product_id);
              if(findPrice){
                price = findPrice.price;
              }
            }
            let qty = this.myService.separator(this.productRequestDetailData[i].qty);
            qty = String(qty).replace(/[^0-9,]/g, '');
            this.productRequestDetailList.push({
              'id' : i + 1,
              'product_id' : this.productRequestDetailData[i].product_id,
              'product_name' : this.productRequestDetailData[i].product_name,
              'qty_request': qty,
              'unit': 'Pcs',
              'product_type':this.productRequestDetailData[i].product_type,
              'source':this.productRequestDetailData[i].source,
              'price':price,
              'proposal_number':this.productRequestDetailData[i].proposal_number
            });
          }
        } else {
          this.productRequestDetailList = [];
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  buildFormProductRequestDetail() {
    let proposalPeriod =null;
    if(this.productRequestData){
      if(this.productRequestData[0].proposal_number!='' && this.productRequestData[0].proposal_number!=null){
        this.showProposal=true;
        this.loadProposal=true;
      }
      else{
        this.getProposal('first_load');
      }
      if(this.productRequestData[0].proposal_start_date && this.productRequestData[0].proposal_end_date && 
        this.productRequestData[0].proposal_start_date !== '0000-00-00' &&
        this.productRequestData[0].proposal_end_date !== '0000-00-00'){
        proposalPeriod = this.productRequestData[0].proposal_start_date+' s/d '+ this.productRequestData[0].proposal_end_date ;
      }
      this.proposalNumber = this.productRequestData[0].proposal_number ? this.productRequestData[0].proposal_number : '';
      this.proposalDesc = this.productRequestData[0].proposal_desc ? this.productRequestData[0].proposal_desc : '';
      this.proposalStartDate = this.productRequestData[0].proposal_start_date  ? this.productRequestData[0].proposal_start_date : '';
      this.proposalEndDate = this.productRequestData[0].proposal_end_date ? this.productRequestData[0].proposal_end_date : '';
    }
    this.formProductRequestDetail = this.fb.group({
      productRequestId: [this.productRequestData ? this.productRequestData[0].id : null],
      docDate: [this.productRequestData ? this.productRequestData[0].doc_date : null],
      needDate: [this.productRequestData ? this.productRequestData[0].need_date : null],
      counterId: [this.productRequestData ? this.productRequestData[0].counter_id : null],
      warehouseId: [this.productRequestData ? this.productRequestData[0].warehouse_id : null],
      description: [this.productRequestData ? this.productRequestData[0].desc : null],
      proposalNumber: [this.productRequestData ? this.productRequestData[0].proposal_number : null],
      proposalPeriod: [proposalPeriod],
      proposalDesc: [this.productRequestData ? this.productRequestData[0].proposal_desc : null],
      status: [this.statusName ? this.statusName : this.requestStatusList[0]]
    });
  }


  async  saveUpdate(action: any, status: any) {
    const checkReguler = this.productRequestDetailList.find(
      x => x.product_type === 'R'
    );

    if (checkReguler) {
      this.saveTransaction(action,status);
      return;
    }

    const alert = await this.alertController.create({
      header: '⚠️ Perhatian',
      subHeader: 'Produk Reguler Belum Ada',
      message: 'Minimal harus ada 1 produk reguler.',
      buttons: [
        {
          text: 'OK',
          role: 'confirm'
        }
      ]
    });
    await alert.present();
  }
  saveTransaction(action: any, status: any) {
    const formProductRequest = this.formProductRequestDetail.value;
    const productRequestBundle = new ProductRequestBundle();
    if(action === 'data') {
      let docDateConvert = this.utilService.convertDate(formProductRequest.docDate);
      let needDateConvert = this.utilService.convertDate(formProductRequest.needDate);
      let docDate = docDateConvert.years + '-' + docDateConvert.months + '-' + docDateConvert.dates;
      let dateOfNeed = needDateConvert.years + '-' + needDateConvert.months + '-' + needDateConvert.dates;
      
      let proposalStartDateConvert = this.utilService.convertDate(
        this.proposalStartDate
      );
      let proposalEndDateConvert = this.utilService.convertDate(
        this.proposalEndDate
      );
      let proposalStartDate =
        proposalStartDateConvert.years +
        "-" +
        proposalStartDateConvert.months +
        "-" +
        proposalStartDateConvert.dates;

      let proposalEndDate =
        proposalEndDateConvert.years +
        "-" +
        proposalEndDateConvert.months +
        "-" +
        proposalEndDateConvert.dates;
      productRequestBundle.productRequest.doc_date = docDate;
      productRequestBundle.productRequest.need_date = dateOfNeed;
      productRequestBundle.productRequest.action = 'edit';
      productRequestBundle.productRequest.desc = formProductRequest.description;
      productRequestBundle.productRequest.proposal_number = this.proposalNumber;
      productRequestBundle.productRequest.proposal_desc = this.proposalDesc;
      productRequestBundle.productRequest.proposal_start_date = proposalStartDate;
      productRequestBundle.productRequest.proposal_end_date = proposalEndDate;
      let arrProduct: any = [];
      let arrQty: any = [];
      let arrUnitType: any = [];
      let arrProductType:any=[];
      let arrSource:any=[];
      let arrPrice :any =[];
      if (
       this.productRequestDetailList.length==0){
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Minimal 1 produk!",
          })
          .then((t) => t.present());
        return;
      }
      for(let x = 0; x < this.productRequestDetailList.length; x++) {
        let htmlIdQtyRequest: any = 'qtyRequest_' + x;
        let qtyRequest: any = (<HTMLInputElement>document.getElementById(htmlIdQtyRequest)).value;

        arrProduct[x] = this.productRequestDetailList[x].product_id;
        arrQty[x] = qtyRequest? this.myService.removeSeparator(qtyRequest) :0;
        arrUnitType[x] = 0;
        arrProductType[x]=this.productRequestDetailList[x].product_type;
        arrSource[x]=this.productRequestDetailList[x].source;
        arrPrice[x] = this.productRequestDetailList[x].price;
      }

      if (
        arrProduct.some((p) => !p || p === null || p === undefined || p === "")
      ) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Terdapat produk yang belum dipilih!",
          })
          .then((t) => t.present());
        return;
      }

      const duplicateProducts = arrProduct.filter((p, i) => {
        const key = `${p}_${arrProductType[i]}`;
        return (
          arrProduct.findIndex(
            (item, index) => `${item}_${arrProductType[index]}` === key
          ) !== i
        );
      });
      if (duplicateProducts.length > 0) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Terdapat produk yang sama (duplikat)!",
          })
          .then((t) => t.present());
        return;
      }

      if (arrQty.some((q) => isNaN(q) || q < 1)) {
        this.utilService.loadingDismiss();
        this.toastCtrl
          .create({
            duration: 2000,
            message: "Qty request minimal 1 untuk setiap produk!",
          })
          .then((t) => t.present());
        return;
      }
      
      let invalidPriceGroup = 0;
      if (arrPrice.some((q, index) => {
        if (isNaN(q) || q < 1) {
          invalidPriceGroup = index ;//+ 1;
          return true;
        }
        return false;
      })) {
        this.utilService.loadingDismiss();
        const product = arrProduct[invalidPriceGroup];
        this.toastCtrl
          .create({
            duration: 2000,
            message: `Price Group ${product} belum ada!`,
          })
          .then((t) => t.present());

        return;
      }
      productRequestBundle.productRequestDetail.product_id = arrProduct;
      productRequestBundle.productRequestDetail.qty = arrQty;
      productRequestBundle.productRequestDetail.unit = arrUnitType;
      productRequestBundle.productRequestDetail.product_type = arrProductType;
      productRequestBundle.productRequestDetail.source = arrSource;
      productRequestBundle.productRequestDetail.price = arrPrice;
    }

    if(action === 'status') {
      let timezoneName;
      if (
        this.userProfile &&
        this.userProfile.counter_detail &&
        this.userProfile.counter_detail.timezone !== undefined
      ) {
        timezoneName = this.timezone[parseInt(this.userProfile.counter_detail.timezone)];
      } else {
        timezoneName = this.timezone[0];
      }
      let convertTime = this.utilService.convertDateWithMoment(new Date(), timezoneName);
      let convertDate = this.utilService.convertDate(new Date());
      let transDate = convertDate.years + '-' + convertDate.months + '-' + convertDate.dates;
      let transTime = convertTime.hours + ':' + convertTime.minutes + ':' + convertTime.seconds;

      productRequestBundle.approvalHistory.transaction_id = this.productRequestId;
      productRequestBundle.approvalHistory.username = this.userProfile.username;
      productRequestBundle.approvalHistory.status = status;
      productRequestBundle.approvalHistory.trans_date = transDate + ' ' + transTime;
    }

    productRequestBundle.productRequest.status = status;
    productRequestBundle.productRequest.updated_by = this.userProfile.username;

    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.requestService.updateRequestBundle(this.productRequestId, productRequestBundle).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmUpdate();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  async showConfirmUpdate() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/product-request']);;
          }
        }
      ]
    });
    await alert.present();
  }

  addDetail() {
    let length = this.productRequestDetailList.length;
    this.productRequestDetailList.push({
      'id' : length + 1,
      'product_id' : null,
      'product_name' : null,
      'unit': null,
      'qty_request':'0',
      'product_type':"R",
      "source":"I",
      "price":'0'
    });
  }

  async findProduct(index: any) {
    const modal = await this.modalController.create({
      component: FindProductComponent,
      componentProps: {
        'productList': this.productList
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then((modelData) => {
      let data = modelData.data;
      if(data) {
        let findProduct = this.productRequestDetailList.findIndex(
          x =>
            x.product_id === data.id &&
            x.source === 'I'
        );
        if(findProduct === -1) {
          let findPrice = this.productPriceGroup.find(x=>x.id==data.id);
          let price = 0;
          if(findPrice){
            price = findPrice.price;
          }
          this.productRequestDetailList[index].product_id = data.id;
          this.productRequestDetailList[index].product_name = data.product_name;
          this.productRequestDetailList[index].product_type = data.product_type;
          this.productRequestDetailList[index].source = 'I';
          this.productRequestDetailList[index].price = price;
        }
        else{
          this.customAlert('Produk Sudah Ada','Produk tidak boleh duplikat');
        }
      }
    });
    return await modal.present();
  }
  
  async customAlert(subHeader:any,message:any){    
    const alert = await this.alertController.create({
      header: '⚠️ Perhatian',
      subHeader: subHeader,//'Produk Reguler Belum Ada'
      message: message,//'Minimal harus ada 1 produk reguler.',
      buttons: [
        {
          text: 'OK',
          role: 'confirm'
        }
      ]
    });
    await alert.present();
  }

  deleteProduct(index: any) {
    this.productRequestDetailList.splice(index, 1);
  }
  onChangeQty(index:any){
    let htmlIdQtyRequest: any = 'qtyRequest_' + index;
    let qtyRequest: any = (<HTMLInputElement>document.getElementById(htmlIdQtyRequest)).value;
    let curWithSeparator = this.myService.separator(qtyRequest);
    curWithSeparator = String(curWithSeparator).replace(/[^0-9,]/g, '');
    this.productRequestDetailList[index].qty_request = curWithSeparator;
  }
  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
  checkNexapproval(){
    let options = {
      "token": this.token,
      "id": this.productRequestId,
      "updated_by": this.userProfile.username,
      "level": this.currentLevel,
    };
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.requestService.sendApprovalPo(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.navCtrl.navigateForward(['/product-request']);
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  async poPreview() {
    const modal = await this.modalController.create({
      component: PoAutoPreviewComponent,
      componentProps: {
        'productRequestId': this.productRequestId,
        'token': this.token
      },
      backdropDismiss: false
    });
    return await modal.present();
  }

  onFileChange(evt: any) {
      /* Hanya menerima satu file */
      const target: DataTransfer = <DataTransfer>evt.target;
      if (target.files.length !== 1) {
        this.toastCtrl
          .create({
            duration: 3000,
            message: "Harap unggah satu file Excel saja.",
          })
          .then((t) => t.present());
        return;
      }

      this.productRequestDetailList = [];

      this.utilService.loadingPresent("Membaca file Excel...").then(() => {
        const reader: FileReader = new FileReader();

        reader.onload = (e: any) => {
          /* Baca data workbook sebagai binary string */
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

          /* Ambil sheet pertama */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* Konversi data sheet menjadi array JSON. header: 1 berarti baris pertama adalah data, bukan header. */
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

          this.utilService.loadingDismiss();
          this.processExcelData(data);
        };

        reader.readAsBinaryString(target.files[0]);
      });

      if (this.fileInput) {
        setTimeout(() => {
          this.fileInput.nativeElement.value = "";
        }, 100);
      }

    }

    async processExcelData(data: any[]) {
      const detailData = data
        .slice(1)
        .filter((row) => row && row.length > 0 && String(row[0]).trim());

      if (detailData.length === 0) {
        this.toastCtrl
          .create({
            duration: 3000,
            message: "Tidak ada data produk yang valid di file Excel.",
          })
          .then((t) => t.present());
        return;
      }

      let isDataValid = true;
      let newDetailList: any[] = [];

      this.productRequestDetailList = [];

      let errorMessages: string[] = [];

      detailData.forEach((row, rowIndex) => {
        const pCode = String(row[0]).trim();
        const qtyString = String(row[1] || "0").replace(/[^0-9]/g, "");
        const qtyRequest = parseInt(qtyString, 10);
        let findPrice = this.productPriceGroup.find(x=>x.id==pCode);
        let price = 0;
        if(findPrice){
          price = findPrice.price;
        }


        const productFound = this.productList.find((p) => p.id === pCode);



        if (!pCode || isNaN(qtyRequest) || qtyRequest <= 0) {
          isDataValid = false;
          errorMessages.push(
            `<b>Baris ${rowIndex + 2}</b>: PCode atau Qty tidak valid.`
          );

          return;
        }

        const isDuplicate = this.productRequestDetailList.some(d => d.product_id === pCode) ||
                            newDetailList.some(d => d.product_id === pCode);

        if (isDuplicate) {
          isDataValid = false;
          errorMessages.push(
            `<b>Baris ${rowIndex + 2}</b>: Produk dengan PCode ${pCode} duplikat.`
          );
          return;
        }

        let detail: any = {
          id: this.productRequestDetailList.length + newDetailList.length + 1,
          product_id: pCode,
          qty_request: String(qtyRequest),
          product_type:this.warehouseType ? this.warehouseType : null,
          source:'I',
          price:price
        };

        if (productFound) {
          detail.product_name = productFound.product_name;
        } else {
          isDataValid = false;
          errorMessages.push(
            `<b>Baris ${
              rowIndex + 2
            }</b>: Produk dengan PCode ${pCode} tidak ditemukan (Cek PCode).`
          );
          return;
        }

        newDetailList.push(detail);

        setTimeout(() => {
          const el = document.getElementById(
            "qtyRequest_" +
              (this.productRequestDetailList.length + newDetailList.length - 1)
          ) as HTMLInputElement;
          if (el) el.value = String(qtyRequest);
        }, 50);
      });

      if (!isDataValid) {
        this.productRequestDetailList = [];

        const alert = await this.alertController.create({
          header: "Import Gagal!",
          subHeader: "Harap perbaiki file Excel Anda:",
          message: `<strong>${
            errorMessages.length
          } Kesalahan Ditemukan.</strong><br><br><ul><li>${errorMessages.join(
            "</li><li>"
          )}</li></ul>`,
          buttons: ["OK"],
        });
        await alert.present();

        return;
      }

      this.productRequestDetailList =
        this.productRequestDetailList.concat(newDetailList);

      this.toastCtrl
        .create({
          duration: 3000,
          message: `${newDetailList.length} produk berhasil ditambahkan dari Excel.`,
        })
        .then((t) => t.present());
    }

    downloadTemplate() {
      const ws_data = [
        ["PCode", "Qty"],
        ["000000", 99],
        ["000000", 99],
      ];

      // Buat worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

      // Buat workbook
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detail Permintaan");

      // Simpan file
      XLSX.writeFile(wb, "Template_Permintaan_Barang.xlsx");
    }
    deleteProposal(){
      this.loadProposal=false;
      this.formProductRequestDetail.patchValue({
        proposalNumber: '',
        proposalPeriod:'',
        proposalDesc:''
      });
      this.productRequestDetailList = this.productRequestDetailList.filter(
        x => x.source !== 'P'
      );
      this.showProposal = false;
      this.proposalNumber = '';
      this.proposalDesc ='';
      this.proposalStartDate='';
      this.proposalEndDate='';
      this.isEditProposal=true;
      //ambil list proposal
      this.getProposal('delete');
    }
    editProposal(){
      this.loadProposal=false;
      this.showProposal = false;
      this.isEditProposal=true;
      this.proposalNumber = '';
      this.proposalDesc ='';
      this.proposalStartDate='';
      this.proposalEndDate='';
      this.formProductRequestDetail.patchValue({
        proposalNumber: '',
        proposalPeriod:'',
        proposalDesc:''
      });
      this.productRequestDetailList = this.productRequestDetailList.filter(
        x => x.source !== 'P'
      );
      //ambil list proposal
      this.getProposal('edit');
    }
  getProposal(src:any) {
    const formProductRequest = this.formProductRequestDetail.value;
    if(this.isEditProposal || src=='first_load' || (src=='doc_date' && this.productRequestData[0].doc_date != formProductRequest.docDate) || (src=='need_date' && this.productRequestData[0].need_date != formProductRequest.needDate)){
      this.proposalList = [];
      
      this.loadProposal=false;
      this.formProductRequestDetail.patchValue({
        proposalNumber: '',
        proposalPeriod:'',
        proposalDesc:''
      });
      this.productRequestDetailList = this.productRequestDetailList.filter(
        x => x.source !== 'P'
      );
      this.showProposal = false;
      this.proposalNumber = '';
      this.proposalDesc ='';
      this.proposalStartDate='';
      this.proposalEndDate='';
      this.utilService.loadingPresent("Harap tunggu...").then(() => {
        const formProductRequest = this.formProductRequestDetail.value;
        let docDateConvert = this.utilService.convertDate(
          formProductRequest.docDate
        );
        let needDateConvert = this.utilService.convertDate(
          formProductRequest.needDate
        );      
        let documentMonth = docDateConvert.months;
        let monthOfNeed = needDateConvert.months;
        let documentYear = docDateConvert.years;
        let yearOfNeed = needDateConvert.years;
        let arrMonth = [documentMonth];
        let arrYear = [documentYear];
        
        if(documentMonth!=monthOfNeed ||  documentYear!=yearOfNeed){
          arrMonth.push(monthOfNeed);
          arrYear.push(yearOfNeed);
        }
        let totalRequest = arrMonth.length;
        let completedRequest = 0;

        for (let i = 0; i < arrMonth.length; i++) {
          let options = {
            token: this.token,
            month: arrMonth[i],
            year: arrYear[i],
            kdcounter: this.counterCode,
            counterId: this.counterId
          };

          this.requestService.apiProposal(options).subscribe(
            (response) => {
              if (response.status.code === 200) {
                this.productPriceGroup = response.mst_product;
                const newData = response.results.data
                  .filter(x => !this.usedProposalList.includes(x.noproposal))
                  .map(x => ({
                    ...x,
                    proposal_display: x.noproposal + ' - ' + x.nama_proposal
                  }));
                  for (let j = 0; j < newData.length; j++) { this.proposalList.push(newData[j]); }
              }

              completedRequest++;

              if (completedRequest === totalRequest) {
                this.utilService.loadingDismiss();
              }
            },
            () => {
              completedRequest++;

              if (completedRequest === totalRequest) {
                this.utilService.loadingDismiss();
              }

              this.toastCtrl
                .create({
                  duration: 2000,
                  message: "Gagal terhubung ke server"
                })
                .then((t) => t.present());
            }
          );
        }
      });
    }
  }
  selectProposal(event){
    this.proposalNumber = event.value.noproposal;
    this.proposalDesc = '';
    this.proposalStartDate = '';
    this.proposalEndDate = '';
    let filterProposal = this.proposalList.find(x=>x.noproposal==this.proposalNumber);
    if(filterProposal){
      this.isEditProposal = true;
      this.productRequestDetailList = this.productRequestDetailList.filter(x=>x.source=='I');
      this.proposalDesc  =filterProposal.nama_proposal;
      this.proposalStartDate  =filterProposal.periodeprogawal;
      this.proposalEndDate  =filterProposal.periodeprogakhir;
      if(filterProposal.details.length>0){
        let length = this.productRequestDetailList.length;
        for(let i=0;i<filterProposal.details.length;i++){
          let findPrice = this.productPriceGroup.find(x=>x.id==filterProposal.details[i].pcode);
          let price = 0;
          if(findPrice){
            price = findPrice.price;
          }
            this.productRequestDetailList.push({
              id: length + 1,
              product_id: filterProposal.details[i].pcode,
              qty_request: String(parseInt(filterProposal.details[i].qty)),
              product_name: filterProposal.details[i].nama_produk,
              unit: 'PCS',
              product_type:filterProposal.details[i].product_type ? filterProposal.details[i].product_type: 'P',
              source:'P',
              price:price,
              proposal_number:this.proposalNumber
            });
        }
      }
    }
  }
}
